import $ from "jquery";

$(document).ready(function() {
  $("a.contextual").each(function() {
    var oldUrl = $(this).attr("href");
    var search =
      window.location.href.indexOf("?") >= 0
        ? window.location.href.split("?")[1]
        : "";
    var newUrl = oldUrl + (oldUrl.indexOf("?") >= 0 ? "&" : "?") + search;
    $(this).attr("href", newUrl);
  });
});
